export type VatRateFormMode = 'create' | 'update';

/**
 * Builds the multipart `vatRate` value for a company product request, or
 * `undefined` when the field must not be appended at all.
 *
 * - create: only a chosen rate is sent (0 is a real 0% rate, sent as '0').
 * - update: `null` ("Belirtilmemiş") is sent as '' so the backend clears the
 *   stored rate; `undefined` leaves the stored rate untouched.
 */
export const vatRateFormValue = (
  vatRate: number | null | undefined,
  mode: VatRateFormMode
): string | undefined => {
  if (vatRate === undefined) return undefined;
  if (vatRate === null) return mode === 'update' ? '' : undefined;
  return String(vatRate);
};
